import React from 'react';

export default function BlogHeader({ currentPage = 'blog', onSignUp }) {
  const isHelp = currentPage === 'help';
  const isPricing = currentPage === 'pricing';

  const handleSignUpClick = (e) => {
    if (onSignUp) {
      e.preventDefault();
      onSignUp();
    }
  };

  return (
    <header style={{
      borderBottom: '1px solid var(--border)',
      background: 'var(--card)',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }}>
      <div style={{
        maxWidth: 'var(--page-max)',
        margin: '0 auto',
        padding: '16px var(--page-pad)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px'
      }}>
        {/* Logo/Brand */}
        <a href="/" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          color: 'inherit',
          textDecoration: 'none'
        }}>
          <picture>
            <source
              srcSet={`${process.env.PUBLIC_URL}/Vballstat-Logo-64.webp`}
              type="image/webp"
            />
            <img
              src={`${process.env.PUBLIC_URL}/Vballstat-Logo-64.png`}
              alt="VBall Stats logo"
              width="36"
              height="36"
              style={{ height: '36px', width: 'auto', display: 'block' }}
            />
          </picture>
          <span style={{ fontWeight: '700', letterSpacing: '0.2px', fontSize: '18px' }}>
            VBall Stats
          </span>
        </a>

        {/* Navigation */}
        <nav style={{
          display: 'flex',
          alignItems: 'center',
          gap: '24px'
        }}>
          <a href="/help" style={{
            color: isHelp ? 'var(--primary)' : 'var(--text)',
            textDecoration: 'none',
            fontSize: '15px',
            fontWeight: isHelp ? '600' : '500',
            transition: 'color 0.2s'
          }}
          onMouseEnter={(e) => !isHelp && (e.target.style.color = 'var(--primary)')}
          onMouseLeave={(e) => !isHelp && (e.target.style.color = 'var(--text)')}>
            Help
          </a>
          <a href="/pricing.html" style={{
            color: isPricing ? 'var(--primary)' : 'var(--text)',
            textDecoration: 'none',
            fontSize: '15px',
            fontWeight: isPricing ? '600' : '500',
            transition: 'color 0.2s'
          }}
          onMouseEnter={(e) => !isPricing && (e.target.style.color = 'var(--primary)')}
          onMouseLeave={(e) => !isPricing && (e.target.style.color = 'var(--text)')}>
            Pricing
          </a>
          <a href="/" onClick={handleSignUpClick} style={{
            padding: '8px 16px',
            background: 'var(--primary)',
            color: 'white',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: '600',
            borderRadius: 'var(--radius-sm)',
            transition: 'background 0.2s',
            whiteSpace: 'nowrap'
          }}
          onMouseEnter={(e) => e.target.style.background = 'var(--primary-hover)'}
          onMouseLeave={(e) => e.target.style.background = 'var(--primary)'}>
            Sign up
          </a>
        </nav>
      </div>
    </header>
  );
}
